module.exports = __webpack_public_path__ + "static/media/change-meal-icon.fecf053c.svg";